/**
 * Onboarding Constants
 *
 * Configuration for first-time user onboarding tour.
 */

export interface OnboardingStep {
  id: string;
  title: string;
  description: string;
  icon: string; // Lucide icon name
  highlight?: 'today' | 'timeline' | 'summary';
}

export const ONBOARDING_STORAGE_KEY = 'have-done:onboarding-completed';

export const ONBOARDING_STEPS: readonly OnboardingStep[] = [
  {
    id: 'welcome',
    title: 'Welcome to Have-Done!',
    description: "Celebrate what you've accomplished instead of stressing about what's left. This isn't a to-do list—it's a record of your wins.",
    icon: 'sparkles',
  },
  {
    id: 'today',
    title: 'Log Your Accomplishments',
    description: 'Quickly capture what you\'ve done. Pick a category, add optional details like time spent or satisfaction, and watch your record grow.',
    icon: 'check-circle',
    highlight: 'today',
  },
  {
    id: 'timeline',
    title: 'See Your History',
    description: 'Browse all your logged accomplishments. Search, filter by category, and rediscover wins you might have forgotten.',
    icon: 'scroll-text',
    highlight: 'timeline',
  },
  {
    id: 'summary',
    title: 'Track Your Progress',
    description: 'Get weekly summaries with stats and category breakdowns. See patterns in what you accomplish and celebrate your streaks.',
    icon: 'bar-chart-3',
    highlight: 'summary',
  },
  {
    id: 'getstarted',
    title: "You're All Set!",
    description: 'Start by logging something you\'ve done today—no matter how small. Every accomplishment counts.',
    icon: 'rocket',
  },
] as const;
